import React, { Fragment, memo } from 'react';
import { bool } from 'prop-types';
import { useBaseUrls, useCurrency, useEnvironmentData, useLocale } from 'hooks';
import ProductCardRedesigned from 'modules/ProductCardContainer/ProductCardContainer';
import { OldProduct } from 'modules/ProductsListing/components';
import { productsCardsShape } from 'shapes';

export const ProductCardsContainer = memo(
    ({ products, redesignedCard, withActionBlock }) => {
        const ProductCard = redesignedCard ? ProductCardRedesigned : OldProduct;
        const { cdn, platform } = useEnvironmentData();
        const [locale] = useLocale();
        const baseUrls = useBaseUrls();
        const [currency] = useCurrency();

        return (
            <Fragment>
                {products.map((product, index) => (
                    <ProductCard
                        key={product.model_id}
                        lazyloadImage={false}
                        index={index}
                        product={product}
                        productId={product.objectID}
                        withActionBlock={withActionBlock}
                        currency={currency}
                        locale={locale}
                        platform={platform}
                        cdn={cdn}
                        baseUrls={baseUrls}
                    />
                ))}
            </Fragment>
        );
    },
);

ProductCardsContainer.propTypes = {
    products: productsCardsShape.isRequired,
    redesignedCard: bool,
    withActionBlock: bool,
};

ProductCardsContainer.defaultProps = {
    redesignedCard: false, // To keep compatibility with old projects (ie. front.www)
    withActionBlock: true,
};

ProductCardsContainer.displayName = 'ProductCardsContainer';

export default ProductCardsContainer;
